var exports = {
  "kL": "xa15a2ab7--fe4c57--container",
  "Oh": "xa15a2ab7--fe4c57--grey",
  "wv": "xa15a2ab7--fe4c57--red",
  "wL": "xa15a2ab7--fe4c57--green",
  "fd": "xa15a2ab7--fe4c57--messages_container",
  "HT": "xa15a2ab7--fe4c57--warning_title_with_icon",
  "i3": "xa15a2ab7--fe4c57--warning_title",
  "u": "xa15a2ab7--fe4c57--warning_info",
  "TV": "xa15a2ab7--fe4c57--warning_info_link",
};

module.exports = exports;
